import state from '@/store/state';
/**
 * Game config
 */
export default {

  RushFootball2: {
    color: '#1b6094',
    icon: 'rush-football2',
    print: {
      active: true,
      routes: {
        offer: true,
        results: true,
      },
      navs: [
        {
          name: 'offer',
          route: 'printOffer',
        },
        {
          name: 'results',
          route: 'printResults',
        },
      ],
    },
    offer: {
      active: true,
    },
    ticketActions: {
      afterclosed: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      closed: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      lost: [],
      open: [
        {
          action: 'cancel',
          conditions: [],
        },
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      payedout: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      rejected: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      won: [
        {
          action: 'payout',
          conditions: [],
        },
      ],
    },
    shortcuts: {
      '+': {
        action: 'ticket',
        active: true,
        name: state.translations.newBet || 'newBet',
        shortcut: '+',
      },
      c: {
        action: 'BetType_combo',
        active: true,
        name: state.translations.activateComboTicket || 'activateComboTicket',
        shortcut: 'c',
      },
      m: {
        action: 'BetType_single',
        active: true,
        name: state.translations.activateSingleTicket || 'activateSingleTicket',
        shortcut: 'm',
      },
      o: {
        action: 'full_offer',
        active: true,
        name: state.translations.fullOffer || 'fullOffer',
        shortcut: 'o',
      },
      '*': {
        action: 'print',
        active: true,
        name: state.translations.print || 'print',
        shortcut: '*',
      },
      '/': {
        action: 'reset_ticket',
        active: true,
        name: state.translations.resetTicket || 'resetTicket',
        shortcut: '/',
      },
    },
  },
  SportradarVirtualFootball: {
    color: '#178685',
    icon: 'rush-football2',
    print: {
      active: true,
      routes: {
        offer: false,
        results: true,
      },
      navs: [
        {
          name: 'results',
          route: 'printResults',
        },
      ],
    },
    offer: {
      active: false,
    },
    ticketActions: {
      afterclosed: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      closed: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      lost: [],
      open: [
        {
          action: 'cancel',
          conditions: [],
        },
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      payedout: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      rejected: [
        {
          action: 'rebet',
          conditions: [],
        },
      ],
      won: [
        {
          action: 'payout',
          conditions: [],
        },
      ],
    },
    shortcuts: {
      '+': {
        action: 'ticket',
        active: true,
        name: state.translations.newBet || 'newBet',
        shortcut: '+',
      },
      c: {
        action: 'BetType_combo',
        active: true,
        name: state.translations.activateComboTicket || 'activateComboTicket',
        shortcut: 'c',
      },
      m: {
        action: 'BetType_single',
        active: true,
        name: state.translations.activateSingleTicket || 'activateSingleTicket',
        shortcut: 'm',
      },
      '*': {
        action: 'print',
        active: true,
        name: state.translations.print || 'print',
        shortcut: '*',
      },
      '/': {
        action: 'reset_ticket',
        active: true,
        name: state.translations.resetTicket || 'resetTicket',
        shortcut: '/',
      },
    },
  },
};
